import React, { Component } from 'react';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { trans } from '../../../../localization';
import TransactionRestaurantTable from './components/TransactionRestaurantTable';
import TransactionRestaurantFilter from './components/TransactionRestaurantFilter';
import {
  EnumMerchantPaidMethod,
  findEnumById,
} from '../../../../constants/enum';

class TransactionRestaurantModal extends Component {
  render() {
    const {
      dialog,
      closeDialogGeneric,
      changeActivePage,
      changePageSize,
      handleChangeFilters,
    } = this.props;
    const { isOpenDialog, table, filters } = dialog;
    const { restaurant, merchantPaidMethod } = filters;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          className="user-wallet-restaurant-modal"
          onRequestClose={closeDialogGeneric}
          width="800px"
        >
          <ModalHeader>
            {trans(
              findEnumById(EnumMerchantPaidMethod, merchantPaidMethod).title,
            )}{' '}
            - {restaurant.name}
          </ModalHeader>
          <ModalBody>
            <TransactionRestaurantFilter
              filters={filters}
              handleChangeFilters={handleChangeFilters}
            />
            <TransactionRestaurantTable
              table={table}
              filters={filters}
              changeActivePage={changeActivePage}
              changePageSize={changePageSize}
            />
          </ModalBody>
          <ModalAction>
            <ModalButton type="cancel" onClick={closeDialogGeneric}>
              {trans('common_close')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

export default TransactionRestaurantModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ReportRestaurant/TransactionRestaurant/TransactionRestaurantModal.jsx